import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "支付时间:", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "砍价设置" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_a_input, {
          value: _ctx.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
          placeholder: "请输入",
          style: {"width":"200px","margin-left":"10px"},
          "addon-after": "分钟"
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"margin-left":"10px","margin-bottom":"100px"},
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}